<template>
  <div class="card-list card-list--clickable">
    <label
      v-if="canUseGooglePay"
      class="card-list__item"
      for="google-pay"
    >
      <div class="card-list__item-section">
        <card-type-icon payment-type="GooglePay" />
        <span class="title title--6 dark">
          Google Pay
        </span>
      </div>

      <div class="card-list__item-section">
        <div class="checkbox-input checkbox-input--radio checkbox-input--default checkbox-input--no-label-text">
          <div class="checkbox-input__option">
            <input
              id="google-pay"
              v-model="localSelectedPaymentMethod"
              class="checkbox-input__input"
              type="radio"
              name="selectedCard"
              value="GooglePay"
            >

            <div class="checkbox-input__label" />
          </div>
        </div>
      </div>
    </label>

    <template v-if="canUseApplePay || forceShowApplePay">
      <label
        for="apple-pay"
        class="card-list__item"
      >
        <div class="card-list__item-section">
          <card-type-icon payment-type="ApplePay" />
          <span class="title title--6 dark">
            Apple Pay
          </span>
        </div>

        <div class="card-list__item-section">
          <div class="checkbox-input checkbox-input--radio checkbox-input--default checkbox-input--no-label-text">
            <div class="checkbox-input__option">
              <input
                id="apple-pay"
                v-model="localSelectedPaymentMethod"
                class="checkbox-input__input"
                type="radio"
                name="selectedCard"
                value="ApplePay"
              >

              <div class="checkbox-input__label" />
            </div>
          </div>
        </div>
      </label>

      <transition name="fade-down-only-in">
        <div
          v-if="!canUseApplePay && selectedPaymentMethod === 'ApplePay'"
          class="banner banner--warning border-radius left flex gap align-center"
        >
          <span class="icon icon--smedium fa-exclamation-triangle" />
          <p>
            Apple Pay Auto Reload payment methods can only be configured in the Safari browser or with an iOS device.
          </p>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'MethodsRadioButtons',

    props: {
      canUseGooglePay: {
        type: Boolean,
        default: false
      },
      canUseApplePay: {
        type: Boolean,
        default: false
      },
      forceShowApplePay: {
        type: Boolean,
        default: false
      },
      selectedPaymentMethod: {
        type: String,
        default: null
      }
    },

    computed: {
      localSelectedPaymentMethod: {
        get() {
          return this.selectedPaymentMethod;
        },
        set(val) {
          this.$emit('method-select', val);
        }
      }
    }
  };
</script>
